const buttonConfig = {
  Button: {
    colorTextLightSolid: 'rgba(0, 0, 0)',
    // colorBgContainer: 'rgba(45,48,50)',
  },
};

const modalConfig = {
  Modal: {
    colorBgElevated: 'rgba(45,48,50)',
    colorBgMask: 'rgba(0, 0, 0, 0.70)',
  },
};

const selectConfig = {
  Select: {
    colorBgContainer: 'rgb(30, 32, 33)',
  },
};

const menuConfig = {
  Menu: {
    colorItemBg: '#181a1d',
  },
};

const cardConfig = {
  Card: {
    colorBgContainer: '#181a1d',
  },
};

const inputConfig = {
  Input: {
    colorBgContainer: 'rgb(30, 32, 33)',
  },
};

const appConfig = {
  token: {
    colorPrimary: 'rgb(245, 150, 0)',
    borderRadius: 4,
    fontFamily: 'RakutenSansUI-Regular',
  },
  components: {
    ...buttonConfig,
    ...modalConfig,
    ...selectConfig,
    ...menuConfig,
    ...cardConfig,
    ...inputConfig,
  },
};

export { appConfig };
